import React, { useEffect, useState } from 'react';
import { Collapse, Icon, Row, Modal } from 'antd';
import { FormInput, MasterDetailForm, FormSelect, FormSubmitButton, FormDatePicker } from '@digital/ui';
import { getAllModalidadesContratoOptions, updateInformacoesComplementares, getDadosGerais } from '@app/api/sas/ordemCompra';
import { hasPermission } from '@app/helpers/permissions';
import { EStatusOrdemCompra } from '@app/enums/EStatusOrdemCompra';
import moment from 'moment';
import { dadosGeraisState, desabilitarAcoesState, ordemCompraIdState, statusCodigoState, stepState } from '../atoms';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Visibility } from '@app/components';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import { EGuidFluxoProcessoEtapa } from '@app/enums/EGuidFluxoProcessoEtapa';
import { RelatorioHomologacaoProps, getRelatorioHomologacao } from '@app/api/sas/relatorioHomologacao';
import CurrencyInput from '@app/components/CurrencyInput';
import { ETipoDemanda } from '@app/enums/ETipoDemanda';
import { ETipoContrato } from '@app/enums/ETipoContrato';
import { EStatusAprovacaoContratoTotvs } from '@app/enums';

const { Panel } = Collapse;

interface Props {
    parteDoFluxo?: boolean;
    ehComprador?: boolean;
    abaFluxoProcesso?: boolean;
}

const WidgetIntegracaoContrato = ({ parteDoFluxo = false, abaFluxoProcesso = false, ehComprador = false }: Props) => {
    const [dadosGerais, setDadosGerais] = useRecoilState(dadosGeraisState);
    const ordemCompraId = useRecoilValue(ordemCompraIdState);
    const [empresa, setEmpresa] = useState<string>();
    const [valorPremiado, setValorPremiado] = useState<number>();

    const statusCodigo = useRecoilValue(statusCodigoState);
    const step = useRecoilValue(stepState);
    const desabilitarAcoes = useRecoilValue(desabilitarAcoesState);

    const [reloadLocal, setReloadLocal] = useState(true);
    const [statusDisable, setStatusDisable] = useState(true);
    const [dataInicial, setDataInicial] = useState<Date>();
    const [dataFinal, setDataFinal] = useState<Date>();

    const [url, setURL] = useState(window.location.href);

    const onReloadLocal = () => {
        setReloadLocal(!reloadLocal);
    };

    if (window.location.href != url) {
        setURL(window.location.href);
        if (window.location.href.toLocaleLowerCase().includes("relhomologacao")) onReloadLocal();
        if (window.location.href.toLocaleLowerCase().includes("integracaoContrato")) onReloadLocal();
    }

    useEffect(() => {
        if (ordemCompraId) {
            getDadosGerais(ordemCompraId)
                .then(data => {
                    if (data) {
                        if (!data.modalidadeContrato) {
                            data.modalidadeContrato = 1;
                            data.tipoControleContrato = 1;
                            data.unidadeMedicao = 1;
                            data.caracteristicaItem = 1;
                            data.controlePrecoQtde = 1;
                        }
                        setDadosGerais(data);
                        if (data.tipo == ETipoDemanda.Aditivo || data.tipo == ETipoDemanda.AditivoFaturamentoDireto) {
                            if (abaFluxoProcesso) {
                                setDataFinal(data.dataFinalWidget);
                            } else {
                                setDataFinal(data.dataFinal);
                            }
                        } else {
                            setDataFinal(data.dataFinal);
                        }
                        
                        setDataInicial(data.dataInicio);
                        if (data.tipo == ETipoDemanda.Aditivo || data.tipo == ETipoDemanda.AditivoFaturamentoDireto) {
                            if (!abaFluxoProcesso)
                                setValorPremiado(data.valorTotalWidget);
                            setEmpresa(data.empresaParaAditivo);
                        }
                    }
                });

            if (dadosGerais.tipo == ETipoDemanda.NovaContratacao) {
                getRelatorioHomologacao(ordemCompraId).then(data => {
                    if (data) {
                        setValorPremiado(data.valorPropostaPremiada);
                    }
                });
            }
        }
    }, [ordemCompraId, reloadLocal]);

    useEffect(() => {
        if (isObjNotEmpty(dadosGerais) && ordemCompraId) {
            if (dadosGerais.tipo == ETipoDemanda.Aditivo || dadosGerais.tipo == ETipoDemanda.AditivoFaturamentoDireto) {
                if (abaFluxoProcesso) {
                    getRelatorioHomologacao(ordemCompraId).then(data => {
                        if (data) {
                            setValorPremiado(data.valorAContratar);
                            setEmpresa(data.nomePropostaPremiada);
                        }
                    });
                }
            } else {
                getRelatorioHomologacao(ordemCompraId).then(data => {
                    if (data) {
                        setValorPremiado(data.valorAContratar);
                        setEmpresa(data.nomePropostaPremiada);
                    }
                });
            }
        }
    }, [abaFluxoProcesso, ordemCompraId, dadosGerais])

    const handleSubmitInformacoesComplementares = (values: any) => {
        const valuesToSend = { ...values };
        valuesToSend.dataFinal = moment(dataFinal).toISOString();
        valuesToSend.dataInicio = moment(dataInicial).toISOString();

        updateInformacoesComplementares(valuesToSend).then((data: any) => {
            if (data.valid) onReloadLocal();
        });
    };

    const ehPCS = () => {
        return dadosGerais && isObjNotEmpty(dadosGerais.modalidadeContratoTotvs)
            ? dadosGerais.modalidadeContratoTotvs.toLowerCase() == ETipoContrato.PCS
            : false;
    };

    useEffect(() => {
        if (statusCodigo == EStatusOrdemCompra.Concluido || desabilitarAcoes || (dadosGerais.statusAprovacaoContratoTotvs && dadosGerais.statusAprovacaoContratoTotvs != EStatusAprovacaoContratoTotvs.NAO_CRIADO)) {
           setStatusDisable(false);
        }
    }, [statusCodigo, desabilitarAcoes]);

    console.log(dadosGerais)
    return (
        <Visibility visible={isObjNotEmpty(dadosGerais) && isObjNotEmpty(statusCodigo)}>
            <Collapse
                bordered={false}
                defaultActiveKey={
                    'fluxoEtapaId' in step && EGuidFluxoProcessoEtapa.HandoverContrato === step.fluxoEtapaId && parteDoFluxo
                        ? undefined
                        : "IntegracaoDeContratoTotvs"
                }
                expandIcon={() => <Icon type="arrows-right_4" />}
            >
                <Panel
                    key="IntegracaoDeContratoTotvs"
                    header={ehPCS() ? "Integração de PCS - Totvs" : "Integração de Contrato - Totvs"}
                >
                    {hasPermission([
                        "SAS_VISUALIZAR_INTEGRACAO_CONTRATO_INFORMACOES_ADICIONAIS",
                    ]) &&
                            <>
                                <MasterDetailForm
                                    initialValues={dadosGerais}
                                    onSubmit={handleSubmitInformacoesComplementares}
                                    actions={[
                                        <>
                                            {ehComprador && statusDisable && !parteDoFluxo && (

                                                <FormSubmitButton
                                                    style={{ margin: 10 }}
                                                    type="success"
                                                    title="salvar"
                                                    noIcon
                                                />
                                            )}
                                        </>
                                    ]}
                                >
                                    <Row>
                                        <FormInput
                                            name='statusAprovacaoContrato'
                                            label={ehPCS() ? "Status da Aprovação do PCS" : "Status da Aprovação do Contrato"}
                                            span={3}
                                            disabled
                                        />

                                        <FormInput
                                            name='statusAprovacaoContratoTotvs'
                                            label={ehPCS() ? "Status PCS TOTVS" : "Status Contrato TOTVS"}
                                            span={3}
                                            disabled
                                        />
                                    </Row>
                                    <Row>
                                        <FormSelect
                                            name="modalidadeContrato"
                                            label={ehPCS() ? "Modalidade de PCS" : "Modalidade de Contrato"}
                                            span={3}
                                            getOptions={getAllModalidadesContratoOptions}
                                            required
                                            disabled={parteDoFluxo || !statusDisable}
                                        />
                                        <FormSelect
                                            name="tipoControleContrato"
                                            label={ehPCS() ? "Tipo de Controle do PCS" : "Tipo de Controle do Contrato"}
                                            span={3}
                                            options={[
                                                { value: 1, text: "01 - Total Nota" },
                                                { value: 2, text: "02 - Item" },
                                            ]}
                                            required
                                            disabled={parteDoFluxo || !statusDisable}
                                        />
                                        <FormSelect
                                            name="unidadeMedicao"
                                            label="Unidade de Medição"
                                            span={2}
                                            options={[
                                                { value: 1, text: "01 - Valor" },
                                                { value: 2, text: "02 - Percentual" },
                                            ]}
                                            required
                                            disabled={parteDoFluxo || !statusDisable}
                                        />
                                        <FormSelect
                                            name="caracteristicaItem"
                                            label="Característica Item"
                                            span={2}
                                            options={[
                                                { value: 1, text: "01 - Aditivo" },
                                                { value: 2, text: "02 - Redutor" },
                                            ]}
                                            required
                                            disabled={parteDoFluxo || !statusDisable}
                                        />
                                        <FormSelect
                                            name="controlePrecoQtde"
                                            label="Controle Preço / Qtde"
                                            span={2}
                                            options={[
                                                { value: 1, text: "01 - Qtde e Preço" },
                                                { value: 2, text: "02 - Qtde Aberta e Preço" },
                                                { value: 3, text: "03 - Limite Custo" },
                                            ]}
                                            required
                                            disabled={parteDoFluxo || !statusDisable}
                                        />
                                    </Row>
                                    <Row>
                                        <FormInput
                                            label={ehPCS() ? "Narrativa do PCS" : "Narrativa do Contrato"}
                                            name="narrativaContrato"
                                            span={12}
                                            required
                                            disabled={parteDoFluxo || !statusDisable}
                                        />
                                    </Row>
                                    <Row>
                                        <FormDatePicker
                                            label="Data Início"
                                            name="dataInicio"
                                            format="DD/MM/YYYY"
                                            value={dataInicial != undefined ? moment(dataInicial) : null}
                                            onChange={
                                                (dataMoment, dataString) => {
                                                    if (dataMoment <= new Date(dataFinal).getTime() || (dataFinal == undefined)) {
                                                        setDataInicial(new Date(dataMoment));
                                                    } else {
                                                        Modal.warn({
                                                            centered: true,
                                                            okText: 'OK',
                                                            title: 'A data INICIAL não deve ser maior que a data FINAL.',
                                                        });
                                                    }
                                                }
                                            }
                                            span={3}
                                            required={dataInicial == undefined}
                                            disabled={parteDoFluxo || !statusDisable}
                                        />
                                        <FormDatePicker
                                            label="Data Final"
                                            name="dataFinal"
                                            format="DD/MM/YYYY"
                                            value={dataFinal != undefined ? moment(dataFinal) : null}
                                            onChange={
                                                (dataMoment) => {
                                                    if (dataMoment >= new Date(dataInicial).getTime() || (dataInicial == undefined)) {
                                                        setDataFinal(new Date(dataMoment));
                                                    } else {
                                                        Modal.warn({
                                                            centered: true,
                                                            okText: 'OK',
                                                            title: 'A data FINAL não deve ser menor que a data INICIAL.',
                                                        });
                                                    }
                                                }
                                            }
                                            span={3}
                                            required={dataFinal == undefined}
                                            disabled={parteDoFluxo || !statusDisable}
                                        />
                                        <FormInput
                                            label={ehPCS() ? "PCS" : "Contrato"}
                                            name={"contrato"}
                                            span={3}
                                            disabled
                                        />
                                        <FormInput
                                            label="Empresa Premiada"
                                            name='empresaPremiada'
                                            value={empresa}
                                            span={3}
                                            disabled
                                        />
                                    </Row>
                                    <Row>
                                        <CurrencyInput
                                            label="Valor Total"
                                            name='valorTotal'
                                            value={valorPremiado}
                                            span={3}
                                            disabled
                                        />
                                    </Row>
                                </MasterDetailForm>
                            </>
                        }
                </Panel>
            </Collapse>
        </Visibility>
    );
};

export default WidgetIntegracaoContrato;
